/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationCertificateType
 */
export interface ApplicationCertificateType {
    /**
     * 
     * @type {Date}
     * @memberof ApplicationCertificateType
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateType
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationCertificateType
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateType
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateType
     */
    courseId: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    studentType: ApplicationCertificateTypeStudentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    nameJa: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    descriptionJa: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCertificateType
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCertificateType
     */
    displayOrder: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCertificateType
     */
    state: ApplicationCertificateTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApplicationCertificateTypeStudentTypeEnum {
    Regular = 'regular',
    Research = 'research',
    Exchange = 'exchange'
}/**
* @export
* @enum {string}
*/
export enum ApplicationCertificateTypeStateEnum {
    Active = 'active',
    Hidden = 'hidden'
}

export function ApplicationCertificateTypeFromJSON(json: any): ApplicationCertificateType {
    return ApplicationCertificateTypeFromJSONTyped(json, false);
}

export function ApplicationCertificateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationCertificateType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'courseId': json['courseId'],
        'studentType': json['studentType'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'description': json['description'],
        'descriptionJa': json['descriptionJa'],
        'required': json['required'],
        'displayOrder': json['displayOrder'],
        'state': json['state'],
    };
}

export function ApplicationCertificateTypeToJSON(value?: ApplicationCertificateType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'courseId': value.courseId,
        'studentType': value.studentType,
        'name': value.name,
        'nameJa': value.nameJa,
        'description': value.description,
        'descriptionJa': value.descriptionJa,
        'required': value.required,
        'displayOrder': value.displayOrder,
        'state': value.state,
    };
}


